module.exports = __webpack_public_path__ + "img/1583043148.ba4914e8.jpg";